import log from 'loglevel'

// In development: show all logs. In production: only warnings and errors.
const level = import.meta.env.DEV ? 'debug' : 'warn'
log.setDefaultLevel(level)

export default log
